<advanced-image *ngIf="image" [cldImg]="image" [ngClass]="classes" [plugins]="plugins"></advanced-image>
